module.exports = __webpack_public_path__ + "img/tmb_ch_khatep_0.f2229bee.png";